import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const UsergroupUsersAddSuccessToast = ({ group, users }) => (
  <PositiveToast className="aridhia-usergroup-users-add-success-toast">
    {users.length === 1 && (
      <FormattedMessage
        id="toast.usergroup.user.assigned"
        values={{ groupName: group.name, userName: users[0].name }}
      />
    )}
    {users.length > 1 && (
      <FormattedMessage
        id="toast.usergroup.users.assigned"
        values={{ groupName: group.name, userName: users[0].name, count: users.length - 1 }}
      />
    )}
  </PositiveToast>
);

export default UsergroupUsersAddSuccessToast;
